import { render, staticRenderFns } from "./custom-object-add-relationship.vue?vue&type=template&id=5e646f83&scoped=true&"
import script from "./custom-object-add-relationship.js?vue&type=script&lang=js&"
export * from "./custom-object-add-relationship.js?vue&type=script&lang=js&"
import style0 from "./custom-object-add-relationship.scss?vue&type=style&index=0&id=5e646f83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e646f83",
  null
  
)

component.options.__file = "custom-object-add-relationship.vue"
export default component.exports